import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { LoadingButton } from '@material-ui/lab';
import { CSVLink } from 'react-csv';
import {
    Card,
    CardContent,
    Grid,
    TextField,
    Typography
} from '@material-ui/core';

function LeadsReports() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState({
        startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
        endDate: new Date().toISOString().slice(0, 10)
    });

    const [catalogHistoryData, setCatalogHistoryData] = useState([]);
    const [catalogHistoryLoading, setCatalogHistoryLoading] = useState(false);
    const [catalogHistoryDate, setCatalogHistoryDate] = useState({
        startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
    });

    const headers = [
        { label: 'Call Date & Time', key: 'date' },
        { label: 'Contact No.', key: 'phoneNumber' },
        { label: 'Seller Name', key: 'sellerName' },
        { label: 'Product Category', key: 'productCategory' },
        { label: 'Alternate No.', key: 'alternateNumber' },
        { label: 'City Name', key: 'city' },
        { label: 'Duration', key: 'duration' },
        { label: 'State Name', key: 'state' },
        { label: 'Call Status', key: 'callStatus' },
        { label: 'Call Remarks', key: 'callRemark' },
        { label: 'Agent ID', key: 'agentId' },
        { label: 'Agent Name', key: 'agentName' }
    ];

    const catalogHistoryHeaders = [
        { label: 'Sent Date & Time', key: 'sentDateTime' },
        { label: 'Phone Number', key: 'phoneNumber' },
        { label: 'Customer Phone', key: 'customerPhone' },
        { label: 'Catalog Name', key: 'catalogName' },
        { label: 'Catalog ID', key: 'catalogId' },
        { label: 'Agent Name', key: 'agentName' },
        { label: 'Agent ID', key: 'agentId' },
        { label: 'File URL', key: 'fileUrl' },
        { label: 'Type', key: 'assetType' }
    ];

    const normalizeCatalogHistoryResponse = (responseData = {}) => {
        const rawRows =
            responseData?.data?.reports ||
            responseData?.data?.history ||
            responseData?.data ||
            [];

        const rows = Array.isArray(rawRows) ? rawRows : [];

        return rows.map((item) => {
            const fileUrl =
                item.previewUrl ||
                item.fileUrl ||
                item.mediaUrl ||
                item.documentUrl ||
                item.imageUrl ||
                item.image ||
                item.pdfUrl ||
                item.link ||
                item.url ||
                '';

            const cleanUrl = String(fileUrl).toLowerCase().split('?')[0];
            let assetType = 'Link';
            if (/\.(png|jpe?g|webp|gif|bmp|svg)$/.test(cleanUrl)) assetType = 'Image';
            if (cleanUrl.endsWith('.pdf')) assetType = 'PDF';

            return {
                ...item,
                sentDateTime: moment(item.sentAt || item.createdAt || item.updatedAt).format('DD-MM-YYYY, hh:mm A'),
                catalogName: item.catalogName || item.name || item.templateName || 'Catalog Entry',
                catalogId: item.catalogId || '',
                agentName: item.agentName || '',
                agentId: item.agentId || '',
                phoneNumber: item.phoneNumber || '',
                customerPhone: item.customerPhone || '',
                fileUrl,
                assetType
            };
        });
    };

    const loadData = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_PATH}/sales/getAllCallReports?startDate=${date.startDate}&endDate=${date.endDate}`).then(res => {
            if (res.data.success) {
                res.data.data.forEach((item) => {
                    item.date = moment(item.createdAt).format('DD-MM-YYYY,hh:mm');
                });
                setData(res?.data?.data || []);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            alert('Something Went Wrong', err);
        });
    };

    const loadCatalogHistoryData = () => {
        setCatalogHistoryLoading(true);
        axios
            .get(`${process.env.REACT_APP_PATH}/whatsapp/catalog-history?startDate=${catalogHistoryDate.startDate}&endDate=${catalogHistoryDate.endDate}`)
            .then((res) => {
                const rows = normalizeCatalogHistoryResponse(res.data);
                setCatalogHistoryData(rows);
                setCatalogHistoryLoading(false);
            })
            .catch((err) => {
                setCatalogHistoryLoading(false);
                alert(err?.response?.data?.message || 'Something went wrong');
            });
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <Grid container spacing={4} item alignItems="center" >
                <Grid xs={12} lg={3} item>
                    <TextField
                        id="datetime-local"
                        label="Start Date"
                        type="date"
                        defaultValue={date.startDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{
                            width: '100%',
                        }}
                        onChange={(e) =>
                            setDate({
                                ...date,
                                startDate: e.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid xs={12} lg={3} item>
                    <TextField
                        id="datetime-local"
                        label="End Date"
                        type="date"
                        defaultValue={date.endDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        style={{
                            width: '100%',
                        }}
                        onChange={(e) =>
                            setDate({
                                ...date,
                                endDate: e.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        onClick={loadData}
                    >
                        <span>Submit</span>
                    </LoadingButton>
                </Grid>
                <Grid item xs={12} lg={3}>
                    {data.length > 0 && !loading && <CSVLink data={data} headers={headers} filename={'Agents Lead Report'} style={{ textDecoration: 'none', border: '1px solid #999', padding: '10px 20px', backgroundColor: '#95c7f1' }} >Download</CSVLink>}
                </Grid>
            </Grid>

            <Card style={{ marginTop: 32, marginBottom: 24 }}>
                <CardContent>
                    <Typography variant="h5" style={{ marginBottom: 20, fontWeight: 700 }}>
                        Catalog History Report
                    </Typography>

                    <Grid container spacing={3} alignItems="center">
                        <Grid xs={12} lg={3} item>
                            <TextField
                                label="Start Date"
                                type="date"
                                value={catalogHistoryDate.startDate}
                                InputLabelProps={{ shrink: true }}
                                style={{ width: '100%' }}
                                onChange={(e) =>
                                    setCatalogHistoryDate({
                                        ...catalogHistoryDate,
                                        startDate: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid xs={12} lg={3} item>
                            <TextField
                                label="End Date"
                                type="date"
                                value={catalogHistoryDate.endDate}
                                InputLabelProps={{ shrink: true }}
                                style={{ width: '100%' }}
                                onChange={(e) =>
                                    setCatalogHistoryDate({
                                        ...catalogHistoryDate,
                                        endDate: e.target.value
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={12} lg={2}>
                            <LoadingButton loading={catalogHistoryLoading} variant="contained" color="primary" onClick={loadCatalogHistoryData}>
                                <span>Submit</span>
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            {catalogHistoryData.length > 0 && !catalogHistoryLoading && (
                                <CSVLink
                                    data={catalogHistoryData}
                                    headers={catalogHistoryHeaders}
                                    filename={`catalog-history-report-${catalogHistoryDate.startDate}-to-${catalogHistoryDate.endDate}.csv`}
                                    style={{
                                        textDecoration: 'none',
                                        border: '1px solid #999',
                                        padding: '10px 20px',
                                        backgroundColor: '#95c7f1',
                                        color: '#000',
                                        borderRadius: 4,
                                        display: 'inline-block'
                                    }}
                                >
                                    Download CSV
                                </CSVLink>
                            )}
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>

        </>
    );
}

export default LeadsReports;
